import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { COLOR_WHITE, COLOR_GRAY_30 } from 'styles/variables/colors';
import { Box, Container, Icon } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import PricingBanner from 'components/PricingBanner';

const Props = {
  showBackButton: PropTypes.bool,
};

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: COLOR_WHITE,
    },
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
    padding: theme.spacing(4, 0, 2, 0),
    borderBottom: `1px solid ${COLOR_GRAY_30}`,
    marginBottom: theme.spacing(3),
  },
  backIcon: {
    cursor: 'pointer',
  },
  mainContent: {
    paddingBottom: theme.spacing(10),
  },
}));

export default function MinimalLayout({ showBackButton, children }) {
  const classes = useStyles();

  return (
    <>
      {/* <PricingBanner /> */}

      <header>
        <Container>
          <Box className={classes.headerContent}>
            {showBackButton && (
              <Link href="/pricing">
                <Icon className={classes.backIcon}>arrow_back</Icon>
              </Link>
            )}

            <Image
              src="/images/mtg-logo-red-editage.svg"
              alt="Mind The Graph Logo"
              height={32}
              width={97}
            />
          </Box>
        </Container>
      </header>

      <main className={classes.mainContent}>{children}</main>
    </>
  );
}

MinimalLayout.props = Props;
